// ============================================================
//  src/components/layout/AppLayout.js
//  Mobile-first layout: bottom nav + page content
// ============================================================
import React from 'react';
import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';
import './AppLayout.css';

export default function AppLayout() {
  return (
    <div className="app-layout">
      <div className="app-main">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
